import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    Bienvenue: 'Welcome',
    Connexion: 'Login',
    Déconnexion: 'Logout',
    Oui: 'Yes',
    Non: 'No',
    Toutes: 'All',
    Opération: 'Operation',
    Production: 'Production',
  },
  fr: {
    Bienvenue: 'Bienvenue',
    Connexion: 'Connexion',
    Déconnexion: 'Déconnexion',
    Oui: 'Oui',
    Non: 'Non',
    Toutes: 'Toutes',
    Opération: 'Opération',
    Production: 'Production',
  },
};

type MessageSchema = typeof messages
const i18n = createI18n<MessageSchema, 'en' | 'fr'>({
  locale: 'fr',
  messages: messages,
  fallbackLocale: ['en', 'fr'],
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
});

export default i18n;
